/**
 * Shared chrome for mobile/desktop header icon buttons (Bug, Alert).
 * Darker gray fill so buttons read as solid controls (Buy/Sell overlay family).
 */
export function headerIconButtonBg(colors, { isLight = false } = {}) {
  return isLight ? '#C5CAD6' : (colors.sidebarBg || 'rgba(255, 255, 255, 0.18)');
}

export function headerIconButtonStyle(colors, { isLight = false, active = false } = {}) {
  const bg = headerIconButtonBg(colors, { isLight });
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    minWidth: 36,
    padding: 0,
    borderRadius: 8,
    boxSizing: 'border-box',
    backgroundColor: active ? `${colors.primary}22` : bg,
    border: `1px solid ${active ? colors.primary : colors.border}`,
    color: colors.primary,
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.15s ease',
  };
}

/** Icon + label chrome (AI, Layout) matching the square alert header button. */
export function headerLabeledIconButtonStyle(colors, { isLight = false, active = false } = {}) {
  return {
    ...headerIconButtonStyle(colors, { isLight, active }),
    width: 'auto',
    minWidth: 36,
    padding: '0 10px',
    gap: 6,
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1,
    boxShadow: 'none',
    whiteSpace: 'nowrap',
  };
}
